import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import { logger } from "../helpers/logger";
import { AppConfig } from '../appConfig';
import { createRootReducer } from "./rootReducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

const middlewares = [
  sagaMiddleware,
];

export const configureStore = (initialState) => {
  const composeEnhancers = composeWithDevTools({});
  const store = createStore(
    createRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  const rootSagaTask = sagaMiddleware.run(rootSaga);
  rootSagaTask.toPromise().catch((error) => logger("Api middleware error", error));

  return { store };
};
